import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { AuthService } from "../auth-service";
import { environment } from "../../../environments/environment";
import { catchError, tap, throwError } from "rxjs";
import { InvoicesError, InvoicesResponse } from "../../pages/admin-dashboard/admin-invoice/admin-invoice.model";

@Injectable({ providedIn: 'root' })
export class InvoiceService  {

  private authService = inject(AuthService);
  private http = inject(HttpClient);
  private API = environment.pharmacyMgtApiUrl;


  getInvoicesByFilters(
    invoiceId?: number,
    orderId?: number,
    pharmacyId?: number,
    pharmacyOwnerId?: number,
    requestStatusId?: number,
    createdOnFrom?: string,
    createdOnTo?: string,
    orderBy: string = 'INVOICE_DATE',
    orderDir: 'ASC' | 'DESC' = 'DESC',
    pageNum: number = 0,
    pageSize: number = 25
  ) {
    const token = this.authService.getAccessToken();

    let headers = new HttpHeaders();

    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }

    let params = new HttpParams();

    if (invoiceId !== undefined && invoiceId !== null) {
      params = params.set('invoiceId', invoiceId);
    }

    if (orderId !== undefined && orderId !== null) {
      params = params.set('orderId', orderId);
    }

    if (pharmacyId !== undefined && pharmacyId !== null) {
      params = params.set('pharmacyId', pharmacyId);
    }

    if (pharmacyOwnerId !== undefined && pharmacyOwnerId !== null) {
      params = params.set('pharmacyOwnerId', pharmacyOwnerId);
    }

    if (requestStatusId !== undefined && requestStatusId !== null) {
      params = params.set('requestStatusId', requestStatusId);
    }

    if (createdOnFrom) {
      params = params.set('createdOnFrom', createdOnFrom);
    }

    if (createdOnTo) {
      params = params.set('createdOnTo', createdOnTo);
    }

    params = params.set('orderBy', orderBy);
    params = params.set('orderDir', orderDir);
    params = params.set('pageNum', pageNum);
    params = params.set('pageSize', pageSize);

    return this.http
      .get<InvoicesResponse>(
        `${this.API}/invoices`,
        {
          headers,
          params,
        }
      )
      .pipe(
        tap(() => console.log('Invoices retrieved successfully')),
        catchError(this.handleError),
      );
  }


  private handleError(error: HttpErrorResponse) {
    const apiError: InvoicesError = error.error;

    console.error('An API error occurred:', apiError);

    return throwError(() => apiError);
  }
}